import React from 'react';
import { Field } from 'react-final-form';

import type { VoucherAmounts } from '../../../../../../types/Cashier';
import SuggestionsSelection from '../SuggestionsSelection/SuggestionsSelection';

import { TXTWCL_Your_voucher_amount } from './VoucherSuggestions.messages.json';

interface Props {
  suggestions: VoucherAmounts;
}

const amountFieldName = 'deposit.amount';
const currencyFieldName = 'deposit.currency';

const VoucherSuggestions: React.FC<Props> = ({ suggestions }) => {
  const [{ currency }] = suggestions;
  return (
    <>
      <Field name={currencyFieldName} type="input" initialValue={currency}>
        {() => <input hidden name={currencyFieldName} type="input" />}
      </Field>
      <SuggestionsSelection
        fieldName={amountFieldName}
        suggestions={suggestions}
        currency={currency}
        label={TXTWCL_Your_voucher_amount}
        isVoucher
      />
    </>
  );
};

export default VoucherSuggestions;
